import { useContext, useEffect, useState } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import styles from './Master.module.css';
import MobiStyles from './MasterMobi.module.css';
import TopBanner from './TopBanner';
import HomePage from '../HomePage/HomePage';
import Footer from './Footer';
import ProductPage from '../ProductPage/ProductPage';
import MnuPage from '../MnuPage/MnuPage';
import SimplePage from '../SimplePage/SimplePage';
import ContactPage from '../ContactPage/ContactPage';
import ShopingCartPage from '../ShopingCartPage/ShopingCartPage';
import { RestMenuContext } from '../Contexts/RestMenu_Context';
import utilsSinglePage from '../Connections/_Utils/utilsSinglePage'
import { SideMenuContext } from '../Contexts/SideMenu_Context';
import { MobiOrNotContext } from '../Contexts/MobiOrNot_Context';
import utilsContactPage from '../Connections/_Utils/utilsContactPage';
import ThankPage from '../SimplePage/ThankPage';
import MyOrdersPage from '../MyOrdersPage/MyOrdersPage';
// import LoginPage from '../StaticPages/LoginPage';
// import LogOrRegPage from '../StaticPages/LogOrRegPage';
// import RegisterPage from '../StaticPages/RegisterPage';

const Master_Main = (props) => {
    const location = useLocation();
    const [lstSimpePages, setLstSimpePages] = useState([]);
    const [lstContactPages, setLstContactPages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);

    const [currnetStyle, setCurrentStyle] = useState(!mobiOrNot ? styles : MobiStyles);

    useEffect(() => {
        setCurrentStyle(!mobiOrNot ? styles : MobiStyles)
    }, [mobiOrNot]);


    useEffect(() => {
        const getSimplePages = async () => {
            let tempo = await utilsSinglePage.allPgsNames();
            setLstSimpePages(tempo);
            setLoading(false);
        };
        getSimplePages();


        const getContactPages = async () => {
            let tempo = await utilsContactPage.allPgsNames();
            setLstContactPages(tempo);
            setLoading(false);
        };
        getContactPages();

    }, []);



    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on every route change
    }, [location]);

    return (
        !loading &&
        <div className={currnetStyle.fullWrap}>
            <div className={currnetStyle.MasterTop}>
                <TopBanner />
            </div>
            <div className={currnetStyle.WebPage}>
                <Routes>
                    <Route exact path="/" element={<HomePage />} scroll-behavior="auto" />
                    <Route path="/?" element={<HomePage />} scroll-behavior="auto" />
                    <Route path={`/Mnu`} element={<MnuPage />} scroll-behavior="auto" />
                    <Route path={`/Mnu/:mnuSec`} element={<MnuPage />} scroll-behavior="auto" />
                    <Route path={`/prods/:productId`} element={<ProductPage />} scroll-behavior="auto" />
                    <Route path="/shopCrt" element={<ShopingCartPage />} scroll-behavior="auto" />
                    <Route path="/myOrders" element={<MyOrdersPage />} scroll-behavior="auto" />
                    {lstSimpePages.map((item, index) => {
                        if (item.inLinkToPage != "thankU") {
                            return (
                                <Route key={index} path={`/${item.inLinkToPage}`}
                                    element={<SimplePage key={index} pageID={item._id} />} />
                            )
                        }
                        else {
                            if (item.inLinkToPage == "thankU") {
                                return (
                                    <Route key={index} path={`/${item.inLinkToPage}`}
                                        element={<ThankPage key={index} pageName={item.pageName}
                                            inLinkToPage={`/${item.inLinkToPage}`}
                                        />} />
                                )
                            }
                        }
                    }
                    )}

                    {lstContactPages.map((item, index) => (
                        <Route key={index} path={`/${item.inLinkToPage}`}
                            element={<ContactPage key={index} pageID={item._id} />} />
                    ))}
                </Routes>
            </div>
            <div className={currnetStyle.MasterBottom}>
                <Footer />
            </div>
        </div>
    );
}

export default Master_Main;
